function initProductTabs() {
  const accordions = Array.from(document.querySelectorAll('.product__accordion'));
  if (accordions.length < 2) return;

  const existingWrapper = document.querySelector('.product__accordion-wrapper');
  if (existingWrapper) existingWrapper.remove();

  const wrapper = document.createElement('div');
  wrapper.className = 'product__accordion-wrapper';

  const tabsNav = document.createElement('div');
  tabsNav.className = 'product__accordion-tabs';

  const contentsWrapper = document.createElement('div');

  accordions.forEach((accordion, index) => {
    const headingEl = accordion.querySelector('.accordion__title');
    if (!headingEl) return;
    const heading = headingEl.textContent.trim();
    const contentEl = accordion.querySelector('.accordion__content');
    if (!contentEl) return;
    const content = contentEl.innerHTML;

    const tabBtn = document.createElement('button');
    tabBtn.className = 'product__accordion-tab-btn' + (index === 0 ? ' active' : '');
    tabBtn.textContent = heading;
    tabsNav.appendChild(tabBtn);

    const contentDiv = document.createElement('div');
    contentDiv.className = 'product__accordion-content' + (index === 0 ? ' active' : '');
    contentDiv.innerHTML = content;
    contentsWrapper.appendChild(contentDiv);

    tabBtn.addEventListener('click', function() {
      document.querySelectorAll('.product__accordion-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product__accordion-content').forEach(c => c.classList.remove('active'));
      tabBtn.classList.add('active');
      contentDiv.classList.add('active');
    });
  });

  wrapper.appendChild(tabsNav);
  wrapper.appendChild(contentsWrapper);

  const firstAccordion = accordions[0];
  firstAccordion.parentNode.insertBefore(wrapper, firstAccordion);

  accordions.forEach(a => a.style.display = 'none');

  // 続きを読む機能
  setTimeout(function() {
    contentsWrapper.querySelectorAll('.product__description-text').forEach(function(text) {
      const btn = text.nextElementSibling;
      if (!btn || !btn.classList.contains('product__description-read-more')) return;
      if (text.scrollHeight <= 100) {
        btn.style.display = 'none';
      } else {
        btn.style.display = 'block';
      }
      btn.addEventListener('click', function() {
        text.classList.add('product__description-text--expanded');
        btn.style.display = 'none';
      });
    });
  }, 100);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductTabs);
} else {
  initProductTabs();
}